import React, { useState, memo } from 'react';
import Singleton from '../../core/singleton';

const OrdersStatusSelector = props => {
    const { getTradByKey } = Singleton.getInstance();
    /** a list of all the status columns */
    const links = [
        {
            label: 'all',
            orders: props.baseOrders,
        },
        {
            label: 'waiting',
            orders: props.baseOrders.filter((order) => ((order.status === "paid") || (order.status === "paid_on_delivery")))
        },
        {
            label: 'canceled',
            orders: props.baseOrders.filter((order) => (order.status === "canceled"))
        },
        {
            label: 'delivered',
            orders: props.baseOrders.filter((order) => (order.status === "delivered"))
        },
        {
            label: 'to_refund',
            orders: props.baseOrders.filter((order) => (order.status === "to_refund")),
            extraClasses: 'd-none d-md-block'
        },
        {
            label: 'refunded',
            orders: props.baseOrders.filter((order) => (order.status === "refunded")),
            extraClasses: 'd-none d-md-block'
        }
    ];

    const [status, setStatus] = useState(links[0].label);
    /** when a click occur on a status */
    const onStatusClick = link => {
        setStatus(link.label);
        props.onStatusChange(link);
    }
    /** when a click occur on a status */
    const List = () => links.map((link, index) =>
        <div key={index} className={`col-3 col-md-2 ${(typeof (link.extraClasses) !== "undefined") ? link.extraClasses : ''}`}>
            <button
                onClick={() => onStatusClick(link)}
                className={`btn btn-primary w-100 d-block text-truncate ${(status === link.label) ? 'active' : ''}`}>
                {getTradByKey(link.label)}
            </button>
        </div>
    )
    return <div className="col-12 OrdersStatusSelector" >
        <div className="row">
            <List />
        </div>
    </div>
}
export default memo(OrdersStatusSelector)